export default __webpack_public_path__ + "static/media/jannis-lucas-KsL8WZJ0CLA-unsplash.de796e53.jpg";